import { useState } from 'react';
import posthog from '../lib/posthog';
import './OnboardingQuestionnaireSlides.css';

const INTENDED_USE_OPTIONS = [
  'Ad Creatives/Marketing',
  'Social Media Content Creation',
  'Software Launch Videos',
  'Entertainment',
];

const HEARD_OPTIONS = [
  'Google',
  'Twitter / X',
  'YouTube',
  'Y Combinator',
  'Friend / Colleague',
  'Other',
];

const LENGTH_OPTIONS = [
  'Under 1 minute',
  '1–5 minutes',
  '5–20 minutes',
  '20+ minutes',
];

export default function OnboardingQuestionnaireSlides({ userId, onDone }) {
  const [step, setStep] = useState(0); // 0..4

  const [intendedUse, setIntendedUse] = useState('');
  const [maxVideoLength, setMaxVideoLength] = useState('');
  const [company, setCompany] = useState('');
  const [role, setRole] = useState('');
  const [heardAboutUs, setHeardAboutUs] = useState('');
  const [heardOther, setHeardOther] = useState('');

  if (!userId) return null;

  const steps = [
    {
      title: 'What do you intend to use Latted for?',
      body: (
        <div className="onboarding-slides-choices">
          {INTENDED_USE_OPTIONS.map((opt) => (
            <button
              key={opt}
              type="button"
              className={`onboarding-slides-choice${intendedUse === opt ? ' is-selected' : ''}`}
              onClick={() => setIntendedUse(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      ),
    },
    {
      title: 'What is the max length of video you need?',
      body: (
        <div className="onboarding-slides-choices">
          {LENGTH_OPTIONS.map((opt) => (
            <button
              key={opt}
              type="button"
              className={`onboarding-slides-choice${maxVideoLength === opt ? ' is-selected' : ''}`}
              onClick={() => setMaxVideoLength(opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      ),
    },
    {
      title: 'What is your Company?',
      body: (
        <input
          className="onboarding-slides-input"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          placeholder="Company"
        />
      ),
    },
    {
      title: 'What is your Role?',
      body: (
        <input
          className="onboarding-slides-input"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          placeholder="Role"
        />
      ),
    },
    {
      title: 'Where did you hear about us?',
      body: (
        <div className="onboarding-slides-stack">
          <div className="onboarding-slides-choices">
            {HEARD_OPTIONS.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`onboarding-slides-choice${heardAboutUs === opt ? ' is-selected' : ''}`}
                onClick={() => setHeardAboutUs(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
          {heardAboutUs === 'Other' && (
            <input
              className="onboarding-slides-input"
              value={heardOther}
              onChange={(e) => setHeardOther(e.target.value)}
              placeholder="Tell us where you heard about Latted"
            />
          )}
        </div>
      ),
    },
  ];

  const isLast = step === steps.length - 1;

  const handleNext = () => setStep((s) => Math.min(steps.length - 1, s + 1));

  const handleSubmit = () => {
    posthog.capture('onboarding completed', {
      intended_use: intendedUse,
      max_video_length: maxVideoLength,
      heard_about_us: heardAboutUs === 'Other' ? heardOther || 'Other' : heardAboutUs,
    });
    onDone?.();
  };

  return (
    <section className="onboarding-slides" aria-label="Onboarding questions">
      <div className="onboarding-slides-progress" aria-hidden="true">
        {steps.map((_, idx) => (
          <div
            key={idx}
            className={[
              'onboarding-slides-dot',
              idx === step ? 'is-active' : '',
              idx < step ? 'is-done' : '',
            ]
              .filter(Boolean)
              .join(' ')}
          />
        ))}
      </div>

      <div className="onboarding-slides-slide">
        <h3 className="onboarding-slides-title">{steps[step].title}</h3>
        <div className="onboarding-slides-body">{steps[step].body}</div>
      </div>

      <footer className="onboarding-slides-actions">
        {isLast ? (
          <button type="button" className="onboarding-slides-btn primary" onClick={handleSubmit}>
            Submit
          </button>
        ) : (
          <button type="button" className="onboarding-slides-btn primary" onClick={handleNext}>
            Next
          </button>
        )}
      </footer>
    </section>
  );
}


